module.exports = __webpack_public_path__ + "static/media/environment-trees.688841c3.svg";